<template>
    <div>
        <FormDialog :title="title" :isShow.sync="isShow" width="900px" v-on:resetForm="close()">
            <div class="home land-form regulations-form" style="padding: 0px 100px;">
                <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
                    <el-form-item label="政策法规标题" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
               <!--  <el-form-item label="单位名称" prop="dwmc">
                    <el-select v-model="form.dwmc">
                        <el-option v-for="(item,index) in companys" v-bind:value="item.companyname" v-text="item.companyname" :command="item" :key="'header'+ index"></el-option>
                    </el-select>
                </el-form-item> -->
                    <el-form-item label="政策法规级别" prop="type">
                        <el-select v-model="form.type">
                            <el-option label="国家级" value="1"></el-option>
                            <el-option label="省级" value="2"></el-option>
                            <el-option label="市级" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="政策法规">
                        <div class="add-img">
                            <pf-file-upload v-model="zcfgUploadList"
                                            :isLimit="false"
                                            :actionUrl="zcfgUrl"
                                            :listType="'text'"
                                             @handleChangeLimit="handleChangeLimit"
                                            :drag="true">
                            </pf-file-upload>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <template v-slot:footer>
                <el-button type="primary" @click="submit()" size="small">保存</el-button>
                <el-button @click="close()" size="small">关闭</el-button>
            </template>
        </FormDialog>
    </div>
</template>
<script>
import FormDialog from '@/components/dialog/formDialog'
import {userInfoApi, regulationsManagementApi} from '@/api/managementSystemApi'
import { Notification } from 'element-ui'
export default {
  name: 'editRegulations',
  components: {
    FormDialog
  },
  data() {
    return {
      isShow: false,
      title: '新增',
      zcfgUploadList: [],
      zcfgUrl: '/openApi/uploadFile/uploadAttachment',
      form: {},
      rules: {
        name: [{ required: true, message: '请输入政策法规标题', trigger: 'blur' },
          { validator: this.$validRule.validHanzi, trigger: 'blur' }],
        dwmc: [{ required: true, message: '请选择单位名称', trigger: 'change' }],
        type: [{ required: true, message: '请选择政策法规级别', trigger: 'change' }]
      },
      companys: []
    }
  },
  methods: {
    open(id, rowData) {
      if (rowData !== undefined) {
        this.form = rowData
      }
      if (id) {
        if (rowData) {
          const zcfgArray = rowData.filepath.split('&')
          for (let i = 0; i < zcfgArray.length; i++) {
            const zcfgurl = zcfgArray[i]
            const oject = {}
            if (zcfgurl.indexOf('/virtualPath/GHFJ/') !== -1) {
              oject.url = zcfgurl
              oject.name = zcfgurl.substr(zcfgurl.lastIndexOf('/') + 1, zcfgurl.length - 1)
            } else {
              oject.url = zcfgurl
              oject.name = zcfgurl
            }
            this.zcfgUploadList.push(oject)
          }
        }
      }
      this.isShow = !this.isShow
      const params = {
        pageNo: 0,
        pageSize: 0,
        params: [
          {
            column: '',
            type: '',
            val: ''
          }
        ]
      }
      userInfoApi.selectCompany(params).then(response => {
        if (response.code === '200') {
          const data = response.data
          this.companys = data
        }
      })
      if (id) {
        this.title = '编辑'
      } else {
        this.title = '新增'
      }
    },

    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 政策法规地址
          this.form.filepath = ''
          for (let i = 0; i < this.zcfgUploadList.length; i++) {
            this.form.filepath += this.zcfgUploadList[i].url + '&'
          }
          this.form.filepath = this.form.filepath.substr(0, this.form.filepath.length - 1)
          if (this.zcfgUploadList.length === 0) {
            Notification.warning({
              title: '提示',
              message: '请上传附件!',
              type: 'warning'
            })
          } else {
            if (this.form.type == '国家级') {
              this.form.type = 1
            } else if (this.form.type == '省级') {
              this.form.type = 2
            } else if (this.form.type == '市级') {
              this.form.type = 3
            }
            regulationsManagementApi.addOrUpdateRegulations(this.form).then(res => {
              if (res.code === '200' && res.data) {
                this.$utils.success('保存成功！')
                this.isShow = false
                this.form = {}
                this.zcfgUploadList = []
                this.$emit('refreshData')
              } else {
                this.$utils.error('保存失败！原因是：' + res.msg)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 文件上传限制1个
    handleChangeLimit(fileList) {
      if (fileList.length > 1) {
        Notification.warning({
          title: '提示',
          message: '最多只能上传一个政策法规附件!',
          type: 'warning'
        })
        fileList.splice(1, 1)
      }
    },
    close() {
      this.isShow = false
      this.form = {}
      this.zcfgUploadList = []
      // this.$emit('refreshData')
    }
  }
}
</script>
<style lang="scss" scoped>
    .regulations-form{
        .add-img {
            cursor: pointer;
            display: inline-block;
            vertical-align: middle;
            ::v-deep {
                > div {
                    line-height: normal;
                    .el-upload-dragger {
                        height: 100%;
                        width: 100%;
                        font-size: 14px;
                        color: #666666;
                        padding: 5px 0px 4px;
                        width: 124px;
                        height: 71px;
                        .el-icon-upload {
                            color: #2f77f1;
                            font-size: 22px;
                            margin: 0px;
                            line-height: 20px;
                        }
                    }
                    .el-upload-list__item{
                        transition: none !important;
                    }
                }
            }
        }
    }
    .land-form {
        table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;

            tr {
                td {
                    font-size: 16px;
                    color: #333333;
                    border: 1px solid #dddddd;
                    padding: 15px 10px;

                    .upload-button-left {
                        margin-right: 10px;

                        ::v-deep {
                            .el-button.el-button--small, .el-button--small.is-round {
                                font-size: 14px;
                                padding: 8px 15px;

                                i.iconfont {
                                    font-size: 14px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }

                    .el-button.el-button--small, .el-button--small.is-round {
                        font-size: 14px;
                        padding: 8px 15px;

                        i.iconfont {
                            font-size: 14px;
                            margin-right: 5px;
                        }
                    }

                    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
                        margin-bottom: 0px;
                    }

                    .el-date-editor.el-input, .el-date-editor.el-input__inner {
                        width: 100%;
                    }

                    &:nth-child(even) {
                        background: #fff;
                    }

                    &:nth-child(odd) {
                        background: #f5f6f8;
                        text-align: right;
                    }

                    &.header {
                        height: 40px;
                        background: #f0f6fa;
                        padding: 0px 10px;
                        text-align: left;
                        font-weight: bold;
                    }

                    .img-list {
                        position: relative;
                        width: 124px;
                        height: 71px;
                        margin-right: 10px;
                        display: inline-block;
                        vertical-align: middle;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        .img-detele {
                            position: absolute;
                            bottom: 0px;
                            width: 100%;
                            height: 20px;
                            background: rgba(0, 0, 0, 0.5);
                            line-height: 20px;
                            color: #fff;
                            text-align: center;
                            cursor: pointer;
                        }
                    }

                    .add-img {
                        cursor: pointer;
                        display: inline-block;
                        vertical-align: middle;
                        ::v-deep {
                            > div {
                                line-height: normal;
                                .el-upload-dragger {
                                    height: 100%;
                                    width: 100%;
                                    font-size: 14px;
                                    color: #666666;
                                    padding: 5px 0px 4px;
                                    width: 124px;
                                    height: 71px;
                                    .el-icon-upload {
                                        color: #2f77f1;
                                        font-size: 22px;
                                        margin: 0px;
                                        line-height: 20px;
                                    }
                                }
                            }
                        }
                    }

                    .tabs {
                        .tabs-label {
                            display: flex;
                            justify-content: center;
                            padding: 0px 20px;
                            background: #f5f6f8;
                            height: 47px;
                            line-height: 47px;
                            padding-top: 5px;
                            border-bottom: 1px solid #ddd;

                            > div {
                                width: calc(100% / 6);
                                text-align: center;
                                height: 43px;
                                line-height: 43px;
                                cursor: pointer;
                                border: 1px solid transparent;

                                &.active {
                                    background: #fff;
                                    border-right: 1px solid #ddd;
                                    border-left: 1px solid #ddd;
                                    border-top: 1px solid #ddd;
                                    border-bottom: 1px solid #fff;
                                }
                            }
                        }

                        .tabs-content {
                            padding: 20px;
                            text-align: left;

                            .el-button {
                                margin-bottom: 10px;
                            }

                            table {
                                width: 100%;

                                th {
                                    height: 40px;
                                    background: #f8f8f9;
                                    font-size: 16px;
                                    font-weight: 600;
                                    color: #515a6e;
                                    text-align: left;

                                    &:first-child {
                                        text-align: center;
                                    }
                                }

                                td {
                                    height: 48px;
                                    background: #ffffff;
                                    font-size: 16px;
                                    font-weight: 400;
                                    color: #333333;
                                    text-align: left;
                                    border: none;
                                    border-bottom: 1px solid #ddd;

                                    &:first-child {
                                        text-align: center;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .el-select {
            width: 100%;

            ::v-deep {
                .el-input-number {
                    .el-input__inner {
                        text-align: left;
                    }
                }
            }
        }
    }
</style>
